module.exports = __webpack_public_path__ + "img/MY.61338227.png";